<div class="filter-section">
  <div class="search-box">
    <span class="p-input-icon-left w-full">
      <i class="pi pi-search"></i>
      <input
        type="text"
        pInputText
        [placeholder]="placeholder"
        [value]="searchTerm"
        (input)="onSearchChange($any($event.target).value)"
        aria-label="Search">
    </span>
  </div>

  <div class="item-count">
    <span>{{ itemCount }} {{ countLabel }} found</span>
  </div>

  <button
    *ngIf="showCreateButton"
    pButton
    pRipple
    [icon]="createButtonIcon"
    [label]="createButtonLabel"
    (click)="onCreateClick()"
    class="create-button">
  </button>
</div>
